// Moves the item so it lands before the element currently at newIndex (pass arr.length to move it to the end).
function arrayMove(arr, oldIndex, newIndex) {
  const clone = arr.slice();
  const [item] = clone.splice(oldIndex, 1);
  clone.splice(oldIndex < newIndex ? newIndex - 1 : newIndex, 0, item);
  return clone;
}

export default arrayMove;
